import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "fury-block-client",
  templateUrl: "./block-client.component.html",
  styleUrls: ["./block-client.component.scss"],
})
export class BlockClientComponent {
  blockReason: string = "";

  constructor(private dialogRef: MatDialogRef<BlockClientComponent>) {}

  onSubmit(): void {
    const payload = {
      blockReason: this.blockReason,
    };
    console.log("حظر العميل:", payload);
    this.dialogRef.close(payload);
  }

  onClose(): void {
    this.dialogRef.close(null);
  }
}
